import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var AmdScrollService = /** @class */ (function () {
    function AmdScrollService() {
        this.$windowScroll = new BehaviorSubject(0);
    }
    AmdScrollService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AmdScrollService.ctorParameters = function () { return []; };
    return AmdScrollService;
}());
export { AmdScrollService };
function AmdScrollService_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdScrollService.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdScrollService.ctorParameters;
    /** @type {?} */
    AmdScrollService.prototype.$windowScroll;
}
//# sourceMappingURL=scroll.service.js.map
//# sourceMappingURL=scroll.service.js.map
